import { red, warmGrey } from '@enlighten/design-system/dist/colors';
import Stack from '@enlighten/design-system/dist/Stack';
import type { TextFieldProps } from '@enlighten/design-system/dist/TextField';
import TextField from '@enlighten/design-system/dist/TextField';
import type { TypographyProps } from '@enlighten/design-system/dist/Typography';
import Typography from '@enlighten/design-system/dist/Typography';

export interface FormItemProps extends TextFieldProps {
	labelProps?: TypographyProps;
}

export default function FormItem({ label, required, labelProps, ...props }: FormItemProps) {
	return (
		<Stack width="100%">
			<Typography
				fontSize={{ xs: 12, md: 15 }}
				fontWeight={500}
				lineHeight={1.5}
				whiteSpace={{ xs: 'pre-line', md: 'normal' }}
				color={warmGrey['700']}
				marginBottom={{ xs: '4px', md: 1 }}
				{...labelProps}
			>
				{label}
				<span style={{ color: red['700'] }}>{required ? ' *' : ''}</span>
			</Typography>
			<TextField {...props} />
		</Stack>
	);
}
